var _g, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgNoFile = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 168,
  height: 148,
  viewBox: "0 0 168 148",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#svg-public/img/no-file.svg__filter0_dddd_104_7522)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 32.5335,
  y: 11.3166,
  width: 117.158,
  height: 117.158,
  rx: 22,
  fill: "white"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M87.9335 41.3166H91.9269C93.5901 41.3166 94.4217 41.3166 95.2043 41.5045C95.8981 41.6711 96.5614 41.9458 97.1698 42.3186C97.8561 42.7392 98.4441 43.3272 99.6202 44.5032L111.947 56.8299C113.123 58.006 113.711 58.594 114.131 59.2803C114.504 59.8887 114.779 60.552 114.946 61.2458C115.134 62.0284 115.134 62.86 115.134 64.5232V71.0666C115.134 72.4749 113.992 73.6166 112.584 73.6166C111.175 73.6166 110.034 72.4749 110.034 71.0666V65.1166L102.044 65.1166C100.654 65.1166 99.4557 65.1167 98.4695 65.0335C97.428 64.9456 96.3935 64.7514 95.4038 64.2274C94.0486 63.5098 92.9403 62.4015 92.2227 61.0463C91.6987 60.0566 91.5045 59.0221 91.4166 57.9806C91.3334 56.9944 91.3335 55.7958 91.3335 54.4064V46.4166H89.1235C85.7491 46.4166 83.3717 46.4186 81.5153 46.5702C79.6886 46.7195 78.5921 47.0009 77.7387 47.4357C75.9794 48.3321 74.549 49.7625 73.6526 51.5218C73.2178 52.3752 72.9364 53.4717 72.7872 55.2983C72.6355 57.1548 72.6335 59.5322 72.6335 62.9066V77.5266C72.6335 80.901 72.6355 83.2784 72.7872 85.1348C72.9364 86.9615 73.2178 88.058 73.6526 88.9114C74.549 90.6707 75.9794 92.1011 77.7387 92.9975C78.5921 93.4323 79.6886 93.7137 81.5153 93.8629C83.3717 94.0146 85.7491 94.0166 89.1235 94.0166C90.3441 94.0166 91.3335 95.006 91.3335 96.2266V96.7954C91.3335 98.0774 90.2943 99.1166 89.0123 99.1166C85.7742 99.1166 83.1884 99.1166 81.1 98.946C78.9579 98.771 77.1155 98.4038 75.4234 97.5416C72.7044 96.1563 70.4938 93.9457 69.1085 91.2267C68.2463 89.5346 67.8791 87.6922 67.7041 85.5501C67.5335 83.4616 67.5335 80.8758 67.5335 77.6375V62.7957C67.5335 59.5574 67.5335 56.9715 67.7041 54.883C67.8791 52.741 68.2463 50.8986 69.1085 49.2064C70.4938 46.4875 72.7044 44.2769 75.4234 42.8915C77.1155 42.0293 78.9579 41.6622 81.1 41.4872C82.9511 41.3359 85.1929 41.3185 87.9335 41.3166ZM96.4335 48.5291L107.921 60.0166H102.146C100.626 60.0166 99.6443 60.0145 98.8983 59.9515C98.1836 59.8912 97.9203 59.789 97.7903 59.7202C97.3385 59.481 96.9691 59.1116 96.7299 58.6598C96.6611 58.5298 96.5589 58.2664 96.4986 57.5517C96.4356 56.8058 96.4335 55.8244 96.4335 54.3046V48.5291Z",
  fill: "#2C2D2E"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M100.037 82.2687L113.261 95.4922",
  stroke: "#2C2D2E",
  strokeWidth: 5,
  strokeLinecap: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M113.263 82.3225L100.042 95.5438",
  stroke: "#2C2D2E",
  strokeWidth: 5,
  strokeLinecap: "round"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "svg-public/img/no-file.svg__filter0_dddd_104_7522",
  x: -0.0000219345,
  y: -0.0000138283,
  width: 167.394,
  height: 147.874,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2.37838
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.95135
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.592157 0 0 0 0 0.592157 0 0 0 0 0.592157 0 0 0 0.12 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_104_7522"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 5.71557
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2.28623
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.592157 0 0 0 0 0.592157 0 0 0 0 0.592157 0 0 0 0.0862625 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_dropShadow_104_7522",
  result: "effect2_dropShadow_104_7522"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 9.09297,
  dy: 4.04132
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4.30476
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.592157 0 0 0 0 0.592157 0 0 0 0 0.592157 0 0 0 0.0715329 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect2_dropShadow_104_7522",
  result: "effect3_dropShadow_104_7522"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -17.1756,
  dy: 4.04132
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 7.67896
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.592157 0 0 0 0 0.592157 0 0 0 0 0.592157 0 0 0 0.06 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect3_dropShadow_104_7522",
  result: "effect4_dropShadow_104_7522"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect4_dropShadow_104_7522",
  result: "shape"
})))));
export { SvgNoFile as ReactComponent };